export const UPDATE_PAGE_ORDERS = "UPDATE_PAGE_ORDERS"
export const UPDATE_PAGE_ORDER_NOTES = "UPDATE_PAGE_ORDER_NOTES"
export const UPDATE_PAGE_ORDERS_HISTORY = "UPDATE_PAGE_ORDERS_HISTORY"
export const REMOVE_ALL_PAGE_ORDERS = "REMOVE_ALL_PAGE_ORDERS"
export const UPDATE_PAGE_ORDER = "UPDATE_PAGE_ORDER"
export const UPDATE_PAGE_ORDER_NOTE = "UPDATE_PAGE_ORDER_NOTE"
export const REMOVE_PAGE_ORDER = "REMOVE_PAGE_ORDER"
export const REMOVE_PAGE_ORDER_NOTE = "REMOVE_PAGE_ORDER_NOTE"
export const UPDATE_PAGE_ORDER_HISTORY = "UPDATE_PAGE_ORDER_HISTORY"